import type { EventInventoryRecord } from "./queryEventInventoryAllSlice";
import type { IGlobalInventoryRawItem } from "./queryGlobalInventorySlice";

export const mapGlobalInventoryRow = (item: IGlobalInventoryRawItem): EventInventoryRecord => ({
	...(item as unknown as EventInventoryRecord),
	Item_ID: item.Listing_ID,
	Item_Price: item.Listing_Price ?? 0,
	Item_Cost: item.Listing_Cost ?? 0,
	Face: item.Listing_Face ?? 0,
	Invoice_ID: item.Invoice_ID ?? null,
	Tags: item.Tags || item.Combined_Tags || null,
	Barcode_Attached: (item.Num_Barcodes ?? 0) > 0,
	PDF_Attached: (item.PdfsAttached ?? 0) > 0,
	BarcodesAttachedNumber: item.Num_Barcodes ?? 0,
	totalPDFsAttached: item.PdfsAttached ?? 0,
	Child_Item_IDs: [item.Listing_ID],
	Seat_Number: 0,
});

export const mapGlobalInventoryBulkRow = (item: IGlobalInventoryRawItem): EventInventoryRecord => {
	const quantity = item.Quantity || 1;
	return {
		...mapGlobalInventoryRow(item),
		Quantity: quantity,
		Seats: item.Seats,
		Item_Cost: (item.Listing_Cost ?? 0) * quantity,
	};
};
